const headerItems = {
  home: {
    name: 'home',
    path: '/',
  },
  aboutMe: {
    name: 'aboutMe',
    path: '/aboutMe'
  },
  projects: {
    name: 'projects',
    path: '/projects'
  },
  contact: {
    name: 'contact',
    path: '/contact'
  },
  login: {
    name: 'login',
    path: '/login'
  },
  dashboard: {
    name: 'dashboard',
    path: '/dashboard'
  },
  logout: {
    name: 'logout',
    path: '#'
  },
};

export default headerItems;